import { css } from '@emotion/react'
import { Fade, Tooltip } from '@mui/material'
import { memo } from 'react'
import type { IUserImage } from '../../../../mfcLogic/api/chatImages'
import IconButton from '../../../Buttons/IconButton'
import { getThemeSpacing } from '../../../styles/appTheme'
import { PAPER_HEIGHTS } from '../../../theme'

export const GIF_HEIGHT = 70
export const GIF_WIDTH = GIF_HEIGHT

const rootStyles = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // height: GIF_HEIGHT,
    // width: GIF_WIDTH,
    // borderRadius: '0',
})

const buttonStyles = css({
    height: GIF_HEIGHT,
    width: GIF_WIDTH,
    borderRadius: 0,
    padding: getThemeSpacing(3.5),
    '&:hover': {
        background: 'none',
    },
})

const imgStyles = css({
    flex: `auto`,
    maxWidth: GIF_WIDTH,
    maxHeight: GIF_HEIGHT,
})
const tooltipStyles = () => ({
    '& .MuiTooltip-popper': {
        zIndex: PAPER_HEIGHTS.emoticon,
    },
    '& .MuiTooltip-tooltip': {
        position: 'relative' as const,
        bottom: '-1rem',
        border: '1px solid #dadde9',
        color: 'white',
        fontSize: 12,
        fontWeight: 'bold' as const,
        maxWidth: 220,
        opacity: 0.9,
    },
})

interface ISmallGif {
    itemData?: IUserImage
    onClickGif(imageData: IUserImage): void
}

const SmallGif = memo((props: ISmallGif) => {
    const { onClickGif, itemData } = props

    if (!itemData) return null

    const { id, shortcut, src } = itemData

    const smallerSrc = !src.includes('photos2/')
        ? src.replace(/(\.gif|\.jpg|\.jpeg)/, '.x50$1')
        : src
    const title = `:${shortcut}`

    const nextItemData = {
        ...itemData,
        shortcut: title,
    }

    const handleOnClick = () => onClickGif(nextItemData)

    return (
        <Tooltip
            css={tooltipStyles}
            disableFocusListener
            disableTouchListener
            enterDelay={250}
            placement="bottom"
            title={title}
            slots={{
                transition: Fade,
            }}
        >
            <div css={rootStyles} key={id} data-testid="Button__Gif">
                <IconButton
                    css={buttonStyles}
                    onClick={handleOnClick}
                    title={title}
                >
                    <img css={imgStyles} src={smallerSrc} />
                </IconButton>
            </div>
        </Tooltip>
    )
})

export default SmallGif
